export interface TourStep {
  id: string;
  path: string;
  icon: string;
}

export const TOUR_STEPS: TourStep[] = [
  {
    id: "readyFlows",
    path: "/app/ready-flows",
    icon: "fa-light fa-wand-magic-sparkles",
  },
  {
    id: "popup",
    path: "/app/onsite/popups",
    icon: "fa-light fa-window-restore",
  },
  {
    id: "socialProof",
    path: "/app/onsite/social-proofs",
    icon: "fa-light fa-users",
  },
  {
    id: "integrations",
    path: "/app/integrations",
    icon: "fa-light fa-plug",
  },
];
